<template>
    <div class="notifications is-right pull-right" aria-label="notifications">
        <a href="#" class="toggle-notifications"
           v-on:click.prevent="toggleNotifications">
            <b-icon icon="bell" size="is-small"></b-icon>
            <b-tag :type="notificationType">{{ total }}</b-tag>
        </a>
        <div class="notifications-dropdown"
             v-on:mouseenter="stopTimer"
             v-on:mouseleave="hideNotifications"
             v-if="nVisible">
            <div class="notifications-header">
                <h6 class="title is-6">
                    <span>Notifications</span>
                    <b-tag>{{ total }}</b-tag>
                </h6>
            </div>
            <div class="notifications-body" :class="{'no-notifications': !hasNotifications}">
                <custom-scrollbar :show-fade="false">
                    <ul id="notifications-list" v-if="hasNotifications">
                        <li id="notification-1" class="notifications-row"
                            v-for="notification in notifications"
                            :key="notification.id"
                            v-on:click="handleNotification($event, notification)">
                            <a href="#" class="notifications-dismiss"
                               v-on:click.stop.prevent="dismissNotification($event, notification.id)">
                                <span>
                                    <b-icon icon="times"></b-icon>
                                    <span>Dismiss</span>
                                </span>
                            </a>
                            <b-icon :icon="notification.icon" :type="notification.type"></b-icon>
                            <p>
                                {{ notification.message }}
                                <span>{{ notification.created_at }}</span>
                            </p>
                        </li>
                    </ul>
                    <b-message v-if="!hasNotifications">
                        <em>You have no Notifications!</em>
                    </b-message>
                </custom-scrollbar>
            </div>
            <div class="notifications-footer" v-if="hasNotifications">
                <a href="#" v-on:click="dismissAllNotifications">Dismiss All</a>
            </div>
        </div>
    </div>
</template>

<script>
import CustomScrollbar from '../Elements/CustomScrollbar'
import { mapGetters, mapState } from 'vuex'
import { ACCOUNT_EXPORT_DOWNLOAD } from '@/store/actions/accounts'

export default {
  name: 'Notifications',
  components: {
    CustomScrollbar
  },
  data () {
    return {
      models: {
        'Account': 'accounts',
        'Property': 'properties',
        'AccountProperty': 'properties',
        'AccountExport': 'account-export'
      },
      nVisible: false,
      nTimer: null
    }
  },
  computed: {
    ...mapState({
      init: state => state.init.all
    }),
    ...mapGetters({
      pusher: 'pusher/init',
      total: 'notifications/total',
      notifications: 'notifications/all'
    }),
    userId: function () {
      return this.init.auth_user.id
    },
    notificationType: function () {
      if (this.total > 0) return 'is-danger'
      return 'is-light'
    },
    hasNotifications: function () {
      return this.notifications.length > 0
    },
    pusherChannel: function () {
      if (!this.pusher) return
      return this.pusher.subscribe('private-user.' + this.userId + '.notifications')
    }
  },
  methods: {
    toggleNotifications: function () {
      this.nVisible = !this.nVisible
      this.stopTimer()
      this.$store.dispatch('notifications/getNotifications')
    },
    hideNotifications: function () {
      this.nTimer = window.setTimeout(() => {
        this.toggleNotifications()
      }, 1000)
    },
    stopTimer: function () {
      if (!this.nTimer) return
      clearTimeout(this.nTimer)
      this.nTimer = null
    },
    dismissNotifications: function (e) {
      setTimeout(() => { // remove the elements
        let dismissedNotifications = document.getElementsByClassName('dismissed')

        while (dismissedNotifications[0]) {
          dismissedNotifications[0].parentNode.removeChild(dismissedNotifications[0])
        }
      }, 250)
    },
    dismissNotification: function (e, notificationId) {
      e.currentTarget.parentNode.classList.add('dismissed')
      this.$store.dispatch('notifications/dismissNotifications', notificationId)
      this.dismissNotifications()
    },
    handleNotification: function (e, notification) {
      e.currentTarget.classList.add('dismissed')
      this.$store.dispatch('notifications/dismissNotifications', notification.id)
      this.dismissNotifications()
      setTimeout(() => {
        // artificial delay to visually aid user with dismissal
        // also prevent animation lag

        // Downloading a recently generated export
        if (notification.link.model === 'AccountExport') {
          this.$store.dispatch(ACCOUNT_EXPORT_DOWNLOAD, { model: notification.link.model_id })
          return
        }

        // This could be re-coded to be dynamic
        let nLink = '/' + this.models[notification.link.model] + '/' + notification.link.model_id
        if (notification.link.child !== undefined) {
          nLink = nLink + '/' + this.models[notification.link.child.model] + '/' + notification.link.child.model_id
        }

        this.$router.push(nLink)
      }, 250)
    },
    dismissAllNotifications: function () {
      this.$store.dispatch('notifications/dismissNotifications', 'all')
    }
  },
  created () {
    if (!this.init.auth_user.via_invite && !this.init.auth_user.via_share_link) {
      this.$store.dispatch('notifications/getNotifications')
      this.pusherChannel.bind('notify.files', () => this.$store.dispatch('notifications/getNotifications'))
      this.pusherChannel.bind('notify.exports', () => this.$store.dispatch('notifications/getNotifications'))
      this.pusherChannel.bind('notify.properties.imported', () => this.$store.dispatch('notifications/getNotifications'))
      this.pusherChannel.bind('notify.properties.flagged', () => this.$store.dispatch('notifications/getNotifications'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/Notifications.vue